import Storage from '@/utils/Storage'

const setCaptionsColor = ({ commit }, data) => {
  commit('UPDATE_EMBED_CAPTIONS_COLOR', data)
  Storage.setItem('captionsColor', data)
}

const setCaptionsBackgroundColor = ({ commit }, data) => {
  commit('UPDATE_EMBED_CAPTIONS_BACKGROUND_COLOR', data)
  Storage.setItem('captionsBackgroundColor', data)
}

const setIntroKey = ({ commit }, data) => {
  commit('UPDATE_INTRO_KEY', data)
}

const setIntroType = ({ commit }, data) => {
  commit('UPDATE_INTRO_TYPE', data)
}

const setIntroStatus = ({ commit }, data) => {
  commit('UPDATE_INTRO_STATUS', data)
}

export {
  setCaptionsColor,
  setCaptionsBackgroundColor,
  setIntroKey,
  setIntroType,
  setIntroStatus,
}
